module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((typeof _vm.content === 'object') && _vm.content.poster != undefined && _vm.content.poster != null) ? _c('div', {
    class: _vm.classes
  }, [_c('div', [_c('div', {
    staticClass: "movie-thumbnail__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.poster.url,
      "alt": _vm.content.poster.alt
    }
  }), _vm._v(" "), (_vm.content.rating) ? _c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.content.rating))]) : _vm._e()]), _vm._v(" "), (!_vm.hideCaption) ? _c('div', {
    staticClass: "movie-thumbnail__caption"
  }, [_vm._t("caption", [(_vm.content.date > _vm.currentTimeStamp && _vm.content.has_sessions_available) ? _c('div', {
    staticStyle: {
      "width": "95%",
      "padding": "5px",
      "margin": "10px auto 3px",
      "background-color": "#007cbd",
      "color": "#ffffff",
      "text-align": "center"
    }
  }, [_vm._v("PRE-BOOK NOW")]) : _vm._e(), _vm._v(" "), (_vm.content.date > _vm.currentTimeStamp) ? [_c('span', {
    staticClass: "caption__release"
  }, [_vm._v("\n\t\t\t\t\t\t\tReleases " + _vm._s(_vm.getFormattedDate(_vm.content.date)) + "\n\t\t\t\t\t\t")])] : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "movie-thumbnail__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('ul', {
    staticClass: "movie-thumbnail__subtitle"
  }, _vm._l((_vm.content.genres), function(genre) {
    return _c('li', [(genre.name) ? [_vm._v("\n                " + _vm._s(genre.name.toLowerCase()) + "\n              ")] : [_vm._v("\n                " + _vm._s(genre.toLowerCase()) + "\n              ")]], 2)
  }))])], 2) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d50f3e7e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/movieCard.vue
// module id = 532
// module chunks = 0